import gql from 'graphql-tag'

export const SIGN_UP = gql`
  mutation signUp ($name: String! $email: String! $password: String! ) {
    sign_up(name: $name, email: $email, password: $password) {
      id
    }
  }
`
